import { api_base } from '../api';
import { toast } from '../../scripts/toast';

export const Contact = {
	send(form) {
		$.ajax({
			url: api_base + '/contact/sendEmail',
			method: 'POST',
			data: form,
			headers: {
				Accept: 'application/json'
			},

			success: function (res) {
				toast({
					title: 'Contacto',
					content: 'Formulario enviado correctamente'
				});
				// console.log(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				toast({
					title: 'Contacto',
					content: 'Error al enviar el formulario (verifica que tu informacion sea correcta)'
				});
				// console.log(err);
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/store/api/contact.js